import { useMutation, useQueryClient } from '@tanstack/react-query';

import { HkdBooksAPI } from 'apis/hkdBooks';

import { TAX_ALERTS_QUERY_KEY } from './queries';

export const useMarkFilingSentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: HkdBooksAPI.markFilingSent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TAX_ALERTS_QUERY_KEY });
    },
  });
};

export const useDismissTaxAlertMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: HkdBooksAPI.dismissTaxAlert,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TAX_ALERTS_QUERY_KEY });
    },
  });
};
